var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.5,
    height: 24,
    viewBox: "0 0 38.5 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(-4.5 -12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    transform: "translate(4.5 12)",
    fill: "rgba(255,255,255,0)",
    stroke: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 8,
    height: 8,
    rx: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(7.125 14.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-0.259 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1",
    "data-name": "Path 1",
    transform: "translate(1.003 1.354) rotate(30)",
    fill: "rgba(255,255,255,0)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.615347146987915 1.182009100914001 L 0.5352044701576233 1.114278674125671 L 0.5164640545845032 0.5170815587043762 L 2.596606731414795 0.5848120450973511 L 2.615347146987915 1.182009100914001 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -4.529953002929688e-06 -4.649162292480469e-06 L 3.081645488739014 0.1003353595733643 L 3.131815671920776 1.699095368385315 L 0.05016565322875977 1.598755359649658 L -4.529953002929688e-06 -4.649162292480469e-06 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_2",
    "data-name": "Path 2",
    transform: "translate(5.172 0.697) rotate(120)",
    fill: "rgba(255,255,255,0)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.089477300643921 1.133878469467163 L 0.5528585910797119 1.034214615821838 L 0.5349137783050537 0.5567170381546021 L 3.071532487869263 0.6563808917999268 L 3.089477300643921 1.133878469467163 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.01498556137084961 0.03590774536132812 L 3.553795576095581 0.1749477386474609 L 3.609405517578125 1.654687762260437 L 0.07059550285339355 1.515647768974304 L 0.01498556137084961 0.03590774536132812 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0.5 14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(4 12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7-2",
    "data-name": "Rectangle 7",
    fill: "rgba(255,255,255,0)",
    stroke: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 8,
    height: 8,
    rx: 1,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    transform: "translate(19 30)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 2,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 1,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    transform: "translate(19 16)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 2,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 1,
    rx: 0.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.1a75468c40344373c480bb2bd61e1e03.svg";
export { ForwardRef as ReactComponent };